import React, { useState } from "react";

const FormCreateMoneyReport = () => {
  const [asset, setAsset] = useState("");
  const [lialibility, setLialibility] = useState("");
  const [modal, setModal] = useState(0);
  const [period, setPeriod] = useState("");
  const [file, setFile] = useState();

  const fileHandler = (e) => {
    const input = e.target.files[0];
    const data = new FormData();
    data.append("PDF", input);
    setFile(data);
  }

  const submitHandler = (e) => {
    e.preventDefault();
    
  };

  return (
    <>
      <form onSubmit={submitHandler}>
        <div className="group-input">
          <label htmlFor="asset">Asset</label>
          <input
            type="text"
            className="rounded-lg"
            required={true}
            value={asset}
            onChange={(e) => setAsset(e.target.value)}
          />
        </div>
        <div className="group-input">
          <label htmlFor="lialibilitas">Lialibilitas</label>
          <input
            type="text"
            className="rounded-lg"
            required={true}
            value={lialibility}
            onChange={(e) => setLialibility(e.target.value)}
          />
        </div>
        <div className="group-input">
          <label htmlFor="modal">Modal</label>
          <input
            type="number"
            className="rounded-lg"
            required={true}
            value={modal}
            onChange={(e) => setModal(e.target.value)}
          />
        </div>
        <div className="group-input">
          <label htmlFor="period">Period</label>
          <input
            type="text"
            className="rounded-lg"
            required={true}
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
          />
        </div>
        <div className="group-input">
          <label htmlFor="pdf">PDF Doc</label>
          <input
            type="file"
            className="rounded-lg"
            required={true}
            onChange={fileHandler}
          />
        </div>
        <div className="btn-group">
          <button
            type="submit"
            className="mx-auto border-2 p-2 w-[150px] rounded-lg btn-save bg-gray-50 hover:bg-white"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default FormCreateMoneyReport;
